<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">

        <sidebar-item
          :link="{
            name: menu_corporate,
            icon: 'fa fa-users text-dtac',
            path: '/portal/corporate'
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="isDtacAdminMenu || isReadOnly"
          :link="{
            name: menu_package,
            path: '/portal/package',
            icon: 'ni ni-ungroup text-dtac'
          }"
        />
        <sidebar-item
          v-if="isDtacAdminMenu || isReadOnly"
          :link="{
            name: menu_pilot_number,
            path: '/portal/pilotnumber',
            icon: 'fa fa-phone-square text-dtac'
          }"
        />
        <sidebar-item
          v-if="isDtacAdminMenu || isReadOnly"
          :link="{
            name: menu_agent_number,
            path: '/portal/number',
            icon: 'fa fa-mobile text-dtac'
          }"
        />
        <sidebar-item
          v-if="isDtacAdminMenu || isReadOnly"
          :link="{
            name: menu_user,
            path: '/portal/users',
            icon: 'fa fa-user text-dtac'
          }"
        />

        <sidebar-item
          v-if="isCorporateAdmin"
          :link="{
            name: menu_mlhg,
            path: '/portal/mlhg',
            icon: 'ni ni-ungroup text-dtac'
          }"
        />
        <sidebar-item
          v-if="isCorporateAdminMenu"
          :link="{
            name: menu_pilot_number,
            path: '/portal/pilotnumber',
            icon: 'fa fa-phone-square text-dtac'
          }"
        />
        <sidebar-item
          v-if="isCorporateAdminMenu"
          :link="{
            name: menu_agent_number,
            path: '/portal/number',
            icon: 'fa fa-mobile text-dtac'
          }"
        />
        <sidebar-item
          v-if="isDtacAdminMenu || isReadOnly"
          :link="{
            name: menu_capacity,
            path: '/portal/capacity',
            icon: 'fa fa-server text-info'
          }"
        />
        <sidebar-item
          :link="{
            name: menu_cdr,
            path: '/portal/record',
            icon: 'ni ni-chart-pie-35 text-info'
          }"
        />
        <sidebar-item
          :link="{
            name: menu_report,
            path: '/portal/report',
            icon: 'ni ni-chart-pie-35 text-info'
          }"
        />
        <!--
          EAS migration. Gated on isMigrationUserMenu ALONE (#47) — deliberately
          not `|| isReadOnly` like the entries above, and no longer on the DTAC
          admin group. Those open pages a read-only user may look at; this one
          deletes and recreates every EAS object a corporate owns, and the route
          guard now refuses anyone outside the API's username allow-list. A menu
          item that leads to a redirect is worse than no menu item.

          Last in the list because it is the rarest thing anyone comes here to
          do, and because a destructive action does not belong next to the
          pages people open every day.

          The icon was `fa fa-exchange` and rendered as nothing. public/index.html
          loads FontAwesome 5.6.3 free from the CDN, pinned by an SRI hash; that
          exact file (its SHA-384 matches the `integrity` attribute) defines
          `.fa,.fas{font-weight:900}` and `.fa,.far,.fas{font-family:"Font Awesome
          5 Free"}`, so a `fa` class renders out of fa-solid-900. In that file
          `.fa-users:before` and `.fa-server:before` — the two working entries
          above — are present, and `.fa-exchange:before` is absent entirely:
          `fa-exchange` is the FontAwesome 4 name, renamed to `fa-exchange-alt`
          in 5, and no v4 shim stylesheet is loaded. With no rule there is no
          `content`, so the pseudo-element draws nothing.

          `.fa-exchange-alt:before{content:"\f362"}` is present in the same file,
          and U+F362 is mapped in fa-solid-900.ttf from the same release, exactly
          as U+F0C0 (users) and U+F233 (server) are, while the v4 exchange
          codepoint U+F0EC is not. Icons that are Pro-only in 5.6.3 (fa-abacus,
          fa-analytics) have no rule in this file at all, so presence here is
          proof the free set ships it.
        -->
        <sidebar-item
          v-if="isMigrationUserMenu"
          :link="{
            name: menu_easmigration,
            path: '/portal/easmigration',
            icon: 'fa fa-exchange-alt text-info'
          }"
        />
        <!--
          The voicemail backup / restore log, behind the same allow-list gate
          as the migration itself (routes.js meta isMigrationUser). It sits
          directly under the migration entry because that is the only reason it
          exists: the backup is taken before a migration and the restore is run
          after one.

          `fa fa-envelope` is the same icon the backup button on the migration
          page carries. It is present in the FontAwesome 5.6.3 free file
          public/index.html pins — `.fa-envelope:before{content:"\f0e0"}`, and
          U+F0E0 is mapped in fa-solid-900.ttf from that release — so unlike the
          v4-named `fa-exchange` above it renders rather than drawing nothing.
        -->
        <sidebar-item
          v-if="isMigrationUserMenu"
          :link="{
            name: menu_voicemaillog,
            path: '/portal/voicemail/backuplog',
            icon: 'fa fa-envelope text-info'
          }"
        />
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    return new PerfectScrollbar(`.${className}`);
  }
  // try to init it later in case this component is loaded async
  setTimeout(() => {
    initScrollbar(className);
  }, 100);
  return null;
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition
  },
  computed: {
    menu_corporate: function() {
      return this.$t("menu.corporate");
    },

    menu_mlhg: function() {
      return this.$t("menu.mlhg");
    },
    menu_number: function() {
      return this.$t("menu.number");
    },
    menu_voicemail: function() {
      return this.$t("menu.voicemail");
    },
    menu_cdr: function() {
      return this.$t("menu.cdr");
    },
    menu_report: function() {
      return this.$t("menu.report");
    },
    menu_nseries: function() {
      return this.$t("menu.nseries");
    },
    menu_package: function() {
      return this.$t("menu.package");
    },
    menu_pilot_number: function() {
      return this.$t("menu.pilot_number");
    },
    menu_agent_number: function() {
      return this.$t("menu.agent_number");
    },
    menu_user: function() {
      return this.$t("menu.user");
    },
    menu_capacity: function() {
      return this.$t("menu.capacity");
    },
    menu_easmigration: function() {
      return this.$t("menu.easmigration");
    },
    menu_voicemaillog: function() {
      return this.$t("menu.voicemaillog");
    },

    ...mapGetters({
      isCorporateSuperAdmin: "Auth/isCorporateSuperAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isReadOnly: "Auth/isReadOnly",

      isCorporateSuperAdminMenu: "Auth/isCorporateSuperAdminMenu",
      isDtacAdminMenu: "Auth/isDtacAdminMenu",
      isCorporateAdminMenu: "Auth/isCorporateAdminMenu",
      isReadOnlyMenu: "Auth/isReadOnlyMenu",
      isMigrationUserMenu: "Auth/isMigrationUserMenu",

      getUser: "Auth/getUser"
    })
  },
  methods: {
    ...mapActions({
      setUser: "Auth/setUser",
      refreshPermission: "Auth/refreshPermission"
    }),
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    }
  },
  mounted() {
    // this.user = localStorage.getItem('user')

    this.initScrollbar();
    // Fire-and-forget (#47): re-read the EAS-migration allow-list so a
    // membership change lands without a re-login. It must not block the render
    // and must not throw — refreshPermission already keeps the last known value
    // on failure, and the catch here is belt and braces for a rejected promise.
    Promise.resolve(this.refreshPermission()).catch(() => {});
  }
};
</script>
<style lang="scss">
.text-dtac {
  color: #e7eaf2;
}
</style>
